/* eslint-disable no-undef */
// order is important!
import 'jquery';
import 'lodash';
import 'moment';
import 'auth0-js';
import 'bootstrap';
import 'bootstrap-datepicker';
import angular from 'angular';
import Raven from 'raven-js';
import RavenAngularPlugin from 'raven-js/plugins/angular';
import svg4everybody from 'svg4everybody';
import checkLocalStorage from './shared/localStorageChecker';
import sentry from '../config/apiKeys.json';
import 'summernote';
import './assets/js/summernote-ext-rtl';

import './assets/css/custom-before-bootstrap.css';
import './assets/css/bootstrap.min.css'; //TODO this file was updated need to be used from package
import 'bootstrap-datepicker/dist/css/bootstrap-datepicker.standalone.min.css';
import './assets/css/style.scss';
import './assets/css/custom.scss';
import 'summernote/dist/summernote.css';

import './app.module';
import './app.routes';

import './shared/typeaheadLocations';
import './shared/dynamicCriteriaWithGroups';
import './shared/modals/editDynamicCriteriaGroupPopup';
import './shared/modals/bulkClaimPopup';
import './shared/criteriaTag';
import './shared/criteriaTagWithExclude';
import './shared/dynamicCriteria/dynamicCriteriaComponent';
import './shared/dynamicCriteriaWithExcluded';
import './shared/locationDynamicCriteria/directive';
import './shared/staticCriteria/staticCriteriaDirective';
import './shared/freeCriteria/freeCriteriaDirective';
import './shared/minMaxCriteria/minMaxCriteriaDirective';
import './shared/staticCriteria/staticDataService';
import './shared/staticCriteria/staticDataFilter';
import './shared/dynamicCriteria/dynamicCriteriaService';
import './shared/tracking/hotjar.module';

import './components/core/configuration/env';
import './components/core/authentication/authenticationService';
import './components/core/configuration/constants';
import './components/core/route/routeService';
import './components/core/route/positionService';
import './components/core/route/campaignService';
import './components/core/route/employerService';
import './components/core/route/companyService';
import './components/core/route/employerRepService';
import './components/core/route/identifiersService';
import './components/core/route/recruiterService';
import './components/core/route/workflowService';
import './components/core/route/searchService';
import './components/core/route/candidateService';
import './components/core/route/candidatesExportService';
import './components/core/route/talentService';
import './components/core/route/talentScoreService';
import './components/core/route/talentForEmployerService';
import './components/core/route/candidateApprovalService';
import './components/core/route/candidatesContactService';
import './components/core/route/statsService';
import './components/core/route/officeService';
import './components/core/route/positionReportService';
import './components/core/route/messageService';
import './components/core/route/complianceService';
import './components/core/commonCode/commonCodeService';
import './components/core/translation/translations';
import './components/core/seachCache/searchCacheService';
import './components/core/filters/commonFilters';
import './components/core/directives/focusInputDirective';
import './components/core/directives/escKeyDirective';
import './components/core/directives/extSubmitDirective';
import './components/core/directives/tooltipDirective';
import './components/core/directives/themedButtonDirective';
import './components/core/directives/customStyledElementsDirective';
import './components/core/directives/tabRightClickDirective';
import './components/core/directives/dynamicTitleDirective';
import './components/core/directives/onFinsihRenderDirective';
import './components/core/directives/inlinemanualDirective';
import './components/core/directives/getCurrentYearDirective';

import './components/talenya/dashboardGraphs/dashboard/services/activeUsersService';
import './components/talenya/dashboardGraphs/dashboard/services/activeJobsService';
import './components/talenya/dashboardGraphs/dashboard/services/converstionKpiService';
import './components/talenya/dashboardGraphs/dashboard/services/annualHiringFunnelService';
import './components/talenya/dashboardGraphs/dashboard/services/annualPerformanceService';
import './components/talenya/dashboardGraphs/dashboard/services/jobListingLineChart';
import './components/talenya/dashboardGraphs/dashboard/services/jobListingAreaChart';
import './components/talenya/dashboardGraphs/dashboard/revenue/revenueStatisticalService';
import './components/talenya/dashboardGraphs/dashboard/revenue/revenueFormatterService';
import './components/talenya/dashboardGraphs/dashboard/revenue/revenueDataService';
import './components/talenya/talenya/talenyaController';
import './components/talenya/jobs/jobsController';
import './components/talenya/dashboardGraphs/dashboard/revenue/revenueWidgetController';
import './components/talenya/jobs/timeLineService';
import './components/talenya/dashboardGraphs/dashboard/services/talentExpertSourcingProductivityService';
import './components/talenya/constants/currencyConstants';
import './components/talenya/dashboardGraphs/dashboard/revenue/revenueConstants';
import './components/talenya/dashboardGraphs/dashboardGraphsController';
import './components/talenya/dashboardGraphs/dashboard/dashboardController';
import './components/talenya/dashboardGraphs/jobSummaries/jobSummariesController';
import './components/talenya/dashboardGraphs/talentExpertHiringFunnel/talentExpertHiringFunnelController';
import './components/talenya/dashboardGraphs/talentExpertHiringFunnelCandidate/talentExpertHiringFunnelCandidateController';
import './components/talenya/dashboardGraphs/talentExpertHiringFunnelOverview/talentExpertHiringFunnelController';
import './components/talenya/dashboardGraphs/talentExpertSourcingProductivity/talentExpertSourcingProductivityController';
import './components/talenya/jobs/employer-popup/component';
import './components/talenya/jobs/comment-popup/component';

import './components/common/notification-placeholder';
import './components/common/dialog-placeholder';
import './components/common/tft-option-list';
import './components/common/tft-option-list/item';
import './components/common/tft-dropdown';
import './components/common/tft-select';
import './components/common/tft-button';
import './components/common/tft-dialog';
import './components/common/tft-notification';
import './components/common/tft-spinner';
import './components/common/tft-action-menu';
import './components/common/tft-tile';
import './components/common/tft-checkbox';
import './components/common/tft-input';
import './components/common/tft-textarea';
import './components/common/tft-autosuggest';
import './components/common/tft-tags-input';
import './components/common/tft-datepicker';
import './components/common/tft-radio-button';
import './components/common/tft-label';
import './components/common/tft-form';
import './components/common/tft-help-popup';
import './components/common/tft-feedback-filter';
import './components/common/candidates-csv-export';
import './components/common/position-calibration-status-label';
import './components/common/position-service-type-label';

import './services/downloadService';
import './services/renderService';
import './services/customInterpolationService';
import './services/modalDialogService';
import './services/utilsService';
import './services/formatterService';
import './services/notificationService';
import './services/documentService';
import './services/printService';
import './services/permissionService';
import './services/impersonationService';
import './services/emailService';
import './services/loggerService';
import './services/browserService';
import './services/contactCandidateService';
import './services/tftTagsService';

import './components/campaignStatus';

import './components/candidate/candidateApproval/candidateApprovalController';
import './components/candidate/services/public-profile-link-generator';
import './components/candidate/services/public-candidate-profile';
import './components/candidate/candidates-list';
import './components/candidate/candidates-list-loading';
import './components/candidate/candidates-list-infinity';
import './components/candidate/details-section';
import './components/candidate/profile';
import './components/candidate/workflow-steps';
import './components/candidate/profile/section/matched-skills/skillsRenderService';
import './components/candidate/profile/section/matched-skills-search/skillsRenderService';

import './components/search/searchController';
import './components/search/searchFilter';
import './components/search/buildCsvService';
import './components/search/searchService';
import './components/search/searchDirectives';
import './components/search/filters-toolbar';
import './components/search/history/component';

import './components/search-new/searchController';
import './components/search-new/searchFilter';
import './components/search-new/diversity-toolbar';
import './components/search-new/buildCsvService';
import './components/search-new/searchService';
import './components/search-new/searchDirectives';
import './components/search-new/filters-toolbar';
import './components/search-new/history/component';
import './components/search-new/modalComponents/searchDataModalCtrl';

import './components/employer/employer/employerController';
import './components/employer/employerJobs/employerJobsController';
import './components/employer/employerJob/employerJobController';
import './components/employer/employerJob/completeJobDefinitionButton';
import './components/employer/employerJob/modalDialogs/editAssociatedEmployerRep/editAssociatedEmployerRepModalCtrl';
import './components/employer/constants/employer-workflow';
import './components/employer/createNew/createNewEmployer';
import './components/employer/associatedEmployersSettings';
import './components/employer/manageUsers/manageUsersController';
import './components/employer/createJob/createJobController';
import './components/employerRequestDemo/employerRequestDemoController';
import './components/employer/service/workflow-step-resolver';
import './components/employer/service/feedback';
import './services/semiDynamicMetadataService';
import './components/employer/search/component';
import './components/employer/search-new/component';
import './components/employer/employerRep/sign-up';
import './components/employer/manageUsers/editEmployerRep/editEmployerRepModalCtrl';

import './components/recruiter/constants/recruiter-workflow';
import './components/recruiter/recruiter';
import './components/recruiter/createEditRecruiter/newEditRecController';
import './components/recruiter/recruiterPositions';
import './components/recruiter/recruiterCandidatesJob/recruiterCandidatesJobController';
import './components/recruiter/recruiterCandidatesJob/recruiterCandidatesJobCacheService';
import './components/recruiter/createNewCandidate/createNewCandidateController';
import './components/recruiter/recruiterSingup/recruiterSingupController';
import './components/recruiter/recruiterOpenJob';
import './components/recruiter/recruiterCandidatesJob/candidates-page';
import './components/recruiter/recruiterCandidatesJob/candidate-page';
import './components/recruiter/recruiterCandidatesJob/candidates-page/candidate-list';
import './components/recruiter/recruiterCandidatesJob/candidates-page/candidate-list/item';
import './components/recruiter/recruiterCandidatesJob/candidate-page/recruiter-action-panel';
import './components/recruiter/recruiterCandidatesJob/candidate-page/details-section';
import './components/recruiter/recruiterCandidatesJob/candidate-page/call-for-action-button';
import './components/recruiter/recruiterCandidatesJob/candidate-page/talent-for-employer-details-section';
import './components/recruiter/recruiterCandidatesJob/workflow-steps';
import './components/recruiter/service/recruiterCandidateService';
import './components/recruiter/service/workflow-step-resolver';
import './components/recruiter/service/feedback';
import './components/recruiter/search/component';
import './components/recruiter/search-new/component';

import './components/reportWithFunnel';

import './components/common/import-candidate-dialog/index';
import './components/common/copy-to-clipboard/index';
import './components/core/positionEvents/positionEventsService';

import './components/contactChannelsIcons';

import './components/login/loginController';
import './components/register/component';
import './components/accountManager/accountManager/accountManagerController';
import './components/reminder/reminderController';
import './components/contactUser/contactUserController';
import './components/contact-user-email';
import './components/searchMyCandidates/searchMyCandidatesController';
import './components/office-list';
import './components/footer';
import './components/email-selection';
import './components/email-selection/email-tile';
import './components/locations/locationsService';

import './components/bulk-message';
import './components/bot-tips';
import './components/web-app-adapter';

import './directives/broken-image-placeholder';
import './directives/elastic';

import './components/position/table/filter-toolbar';
import './components/position/table/sort-columns';
import './components/position/on-boarding-timeline';
import './components/position/insight/modalDialogs/modalsController';
import './components/position/insight/component';
import './components/position/insight/employerInsightLink';
import './components/position/insight/services/InsightService';

import './components/widgets/socialintents-live-chat';

import './services/webAppRouteService';

Raven
    .config(sentry.sentryioKey, {
        release: VERSION,
        environment: ENVIRONMENT,
    })
    .addPlugin(RavenAngularPlugin, angular)
    .install();

svg4everybody({ polyfill: true });
checkLocalStorage(BUILD_DATE);

document.addEventListener('DOMContentLoaded', () => {
    document.dispatchEvent(new Event('applicationSourceLoaded'));
});
